<div [formGroup]="blockedNipForm" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()" [class.spinner]="processingRequest"
            [disabled]="!blockedNipForm.valid || processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button tabindex="-1"  (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <mat-card>
    <div fxLayout="column" fxLayoutGap="15px">
      <h3>NIP</h3>
    </div>
    <div fxLayout="row" fxLayoutGap="10px">
      <div fxFlex="15">
        <mat-form-field class="add-input">
          <mat-label>NIP</mat-label>
          <input matInput placeholder="NIP" formControlName="nip" [required]="true">
          <mat-error *ngIf="blockedNipForm.get('nip')?.hasError('required')">To pole jest wymagane</mat-error>
          <mat-error *ngIf="blockedNipForm.get('nip')?.hasError('invalidNip')">Podaj prawidłowy numer NIP</mat-error>
          <mat-error *ngIf="blockedNipForm.get('nip')?.hasError('backendError')">{{errors.nip}}</mat-error>
          <mat-error *ngIf="blockedNipForm.get('nip')?.hasError('nipBlocked')">Numer NIP jest zablokowany</mat-error>
          <mat-error *ngIf="blockedNipForm.get('nip')?.hasError('partnerExists')">Partner z podanym numerem NIP już istnieje.</mat-error>

        </mat-form-field>
        <div fxFlex="5">
          <button *ngIf="blockedNipForm.get('nip')?.value" (click)="getGus()" mat-icon-button color="primary" matTooltip="Pobierz dane z GUS">
            <mat-icon>send</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div fxLayout="column" fxLayoutGap="15px">
      <h3>Nazwa działalności</h3>
      <div fxLayout="row" fxLayoutGap="15px">
        <div fxFlex="100">
          <mat-form-field fxFlex="80" >
            <mat-label>Nazwa działalności</mat-label>
            <input matInput placeholder="Nazwa działalności" formControlName="businessName" [required]="true">
            <mat-error *ngIf="blockedNipForm.get('businessName')?.hasError('required')">To pole jest wymagane</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </mat-card>

  <app-address-form
    [title]="'Adres siedziby'"
    [addressForm]="headquartersAddress"
    [required]="true">
  </app-address-form>

  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()" [class.spinner]="processingRequest"
            [disabled]="!blockedNipForm.valid || processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button tabindex="-1"  (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
